import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEmailGroupById,
  updateEmailGroup,
} from "../../../../../store/emailGroup";
// kendo
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
// routes
import { ADMIN_TOOLS_EMAIL_GROUP_LIST } from "../../../../../routes";
// component
import { EmailGroupForm } from "../form";
// permissions
import {
  getUserPermission,
  checkMultiPermission,
} from "../../../../../config/permission_helper";
import { ADMIN_TOOLS_FOB_ADD_EDIT_EMAIL_GROUP } from "../../../../../config/permission_helper";
// image
import ArrorRightIcon from "../../../../../assets/common/arrao-right.svg";
import BackIcon from "../../../../../assets/communication/Back.svg";
import EditIcon from "../../../../../assets/common/edit_icon.svg";
// css
import "../email_group.css";

export const EmailGroupDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const email_group_id = query.get("id");

  // state
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  // redux
  const {
    email_group_details_loading,
    email_group_details,
    email_group_details_error,
  } = useSelector((state) => state.emailGroup);

  // method
  const shouldShowAddButton = () => {
    const userPermissions = getUserPermission();
    return checkMultiPermission(
      userPermissions,
      ADMIN_TOOLS_FOB_ADD_EDIT_EMAIL_GROUP
    )
      ? true
      : false;
  };

  const handleSaveEmailGroup = (data) => {
    console.log("handleSaveEmailGroup: ", data);
    dispatch(updateEmailGroup({ id: email_group_id, data: data })).then(() => {
      setLoading(false);
      navigate(ADMIN_TOOLS_EMAIL_GROUP_LIST);
    });
  };

  // useEffect
  useEffect(() => {
    if (email_group_id) {
      dispatch(fetchEmailGroupById(email_group_id));
    }
  }, []);

  return (
    <>
      <div className="email-group-detail-body">
        {loading || email_group_details_loading ? (
          <Loader
            type="infinite-spinner"
            style={{
              display: "flex",
              alignItems: "center",
              width: "40px",
              margin: "auto",
              justifyContent: "center",
              height: "100vh",
            }}
          />
        ) : (
          <>
            <div className="email-group-detail-header">
              <div
                className="email-group-detail-group-div"
                onClick={() => navigate(ADMIN_TOOLS_EMAIL_GROUP_LIST)}
              >
                <img src={BackIcon} className="email-group-detail-icon" />
                <span className="email-group-detail-label">Back</span>
              </div>
              {!isEdit && shouldShowAddButton() && (
                <div>
                  <Button
                    className="email-group-detail-edit-btn"
                    onClick={() => setIsEdit(true)}
                  >
                    <img src={EditIcon} style={{ verticalAlign: "middle" }} />
                    <span className="email-group-detail-edit-btn-label">
                      Edit
                    </span>
                    <img
                      src={ArrorRightIcon}
                      style={{ verticalAlign: "middle" }}
                    />
                  </Button>
                </div>
              )}
            </div>
            <div className="email-group-detail-content">
              <EmailGroupForm
                id={email_group_id}
                data={email_group_details}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                setLoading={setLoading}
                submitForm={handleSaveEmailGroup}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};
